import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';

@Component({
  selector: 'app-ping-table',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./ping-table.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class PingTableComponent extends BaseListComponent implements OnInit {

  options = { header: false };
  @Input() id: number;
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public service: BaseRichService,
    public translator: TranslateService
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.title = 'nodes';
    this.entity = 'node_log';
  }

  getApi(): string {
    return 'api/node/readLog';
  }

  getBody(): any {
    const body = super.getBody();
    body['id'] = this.id;
    return body;
  }

}
